export default "__VITE_ASSET__d9ab9bbc__"